import React from 'react';

import { Alert, AlertProps } from '@mui/material';
import classNames from 'classnames';

import classes from './LbAlert.module.scss';

type LbAlertProps = { size?: 'small' | 'medium' } & AlertProps;

const LbAlert = ({
  children,
  size = 'medium',
  className,
  ref,
  ...props
}: LbAlertProps) => {
  const alertClasses = classNames(classes[size], className);

  return (
    <Alert ref={ref} {...props} className={alertClasses}>
      {children}
    </Alert>
  );
};

export { LbAlert, LbAlertProps };
